import { render, staticRenderFns } from "./PatientOverviewActionCard.vue?vue&type=template&id=03e612fa&scoped=true&"
import script from "./PatientOverviewActionCard.vue?vue&type=script&lang=js&"
export * from "./PatientOverviewActionCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientOverviewActionCard.vue?vue&type=style&index=0&id=03e612fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e612fa",
  null
  
)

export default component.exports